import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppModeService } from 'src/app/services/app-mode.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Subject, takeUntil } from 'rxjs';

interface ProfileMenuItem {
  labelKey: string;
  route?: string;
}

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
})
export class ProfileComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  currentLang = localStorage.getItem('lang') || 'en';
  profileName = 'User';
  profileImage = 'assets/img/jersey1.jpg';

  accountItems: ProfileMenuItem[] = [
    {
      labelKey: 'PROFILE.PERSONAL_INFO_TITLE',
      route: '/profile/personal-information',
    },
    {
      labelKey: 'PROFILE.CHANGE_PASSWORD_TITLE',
      route: '/profile/change-password',
    },
    {
      labelKey: 'CHOOSE_LANGUAGE.TITLE',
      route: `/${this.currentLang}/choose-language`,
    },
    { labelKey: 'PROFILE.WISHLIST', route: '/wishlist' },
    { labelKey: 'PROFILE.ADDRESSES.PAGE_TITLE', route: '/profile/addresses' },
    { labelKey: 'PROFILE.MYORDERS_TITLE', route: '/profile/myorders' },
  ];

  preferenceItems: ProfileMenuItem[] = [
    { labelKey: 'FOOTER.ABOUT_US', route: '/about' },
    { labelKey: 'FOOTER.PRIVACY', route: '/privacy' },
    { labelKey: 'FOOTER.TERMS', route: '/t&c' },
  ];

  constructor(
    private readonly router: Router,
    public readonly appModeService: AppModeService,
    private readonly authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.authService.currentUser$
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (!user) {
          const lang = localStorage.getItem('lang') || 'en';
          this.router.navigateByUrl(`/${lang}/home`);
          return;
        }

        this.profileName = user.name || 'User';
        this.profileImage =
          !user.picture || user.picture === 'noimage'
            ? 'assets/img/jersey1.jpg'
            : user.picture;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goBack(): void {
    const lang = localStorage.getItem('lang') || 'en';
    this.router.navigateByUrl(`/${lang}/home`);
  }

  onMenuItemClick(item: ProfileMenuItem): void {
    if (!item.route) {
      return;
    }
    this.router.navigate([item.route]);
  }

  onLogout(): void {
    const lang = localStorage.getItem('lang') || 'en';
    this.authService.logout().subscribe(() => {
      this.router.navigateByUrl(`/${lang}/home`);
    });
  }

  onDeleteAccount(): void {
    const confirmed = window.confirm(
      'Are you sure you want to delete your account?',
    );
    if (!confirmed) {
      return;
    }

    const lang = localStorage.getItem('lang') || 'en';
    this.authService.deleteAccount().subscribe(() => {
      this.router.navigateByUrl(`/${lang}/home`);
    });
  }
  get isRTL(): boolean {
    return document.documentElement.dir === 'rtl';
  }
}
